<template>
    <div class="index container">
        <ShowMumblCard :editActive="editActive" />
    </div>
</template>

<script>
import firebase from 'firebase'
import db from '@/firebase/init'
import  ShowMumblCard from '@/components/frontend/ShowMumblCard'

export default {
    name: 'Index',
    // receive passed data from parent (App.vue)
    props: [
        'editActive',
        'isAdmin'
    ],
    components: {
        ShowMumblCard
    },
    data () {
        return {
            user: null
        }
    },
    methods: {

    },
    created() {
    },
    mounted() {

    }
}
</script>


<style lang="scss">


</style>



// WEBPACK FOOTER //
// src/components/frontend/Index.vue